'use client'
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/components/events/carousel/CarouselTitle.tsx
import { Button, Typography } from "@wbk/ui";
import { Link } from "@wbk/config";
import { ChevronIcon } from "@wbk/svg";
import { useDeviceDetect } from "@wbk/hooks";
import { useAnalytics } from "@wbk/analytics";
import { jsx, jsxs } from "react/jsx-runtime";
var CarouselTitle = ({ section, sectionLink }) => {
  const { isMobile } = useDeviceDetect();
  const clickableTitle = isMobile && sectionLink;
  const Component = clickableTitle ? Link : "div";
  const { trackEvent } = useAnalytics();
  const trackSectionLink = () => {
    if (!(sectionLink == null ? void 0 : sectionLink.href)) return;
    trackEvent({
      event: "clicked_on_section_item",
      data: {
        type: "see_all",
        slug: sectionLink.href,
        section: section == null ? void 0 : section.id,
        label: sectionLink.label
      }
    });
  };
  return /* @__PURE__ */ jsxs("div", { className: "flex w-full items-start justify-between gap-1", children: [
    /* @__PURE__ */ jsxs(
      Component,
      __spreadProps(__spreadValues({}, sectionLink && {
        to: sectionLink.href,
        className: "p-0 flex flex-col text-start items-start rounded-none ",
        onClick: trackSectionLink
      }), {
        children: [
          section.title && /* @__PURE__ */ jsx(Typography, { as: "h2", variant: "heading-L", children: section.title }),
          section.subtitle && /* @__PURE__ */ jsx(Typography, { color: "text-secondary", className: "mt-1", children: section.subtitle })
        ]
      })
    ),
    sectionLink && sectionLink.href && /* @__PURE__ */ jsxs(
      Button,
      {
        as: Link,
        href: sectionLink.href,
        onClick: trackSectionLink,
        shape: "text",
        theme: "action",
        className: "rounded-S flex h-[30px] w-[30px] shrink-0 items-center justify-center p-0 md:h-auto md:w-auto md:px-2 md:py-1",
        target: sectionLink.isExternal ? "_blank" : void 0,
        rel: sectionLink.isExternal ? "noopener noreferrer" : void 0,
        "aria-label": sectionLink.label || "",
        children: [
          /* @__PURE__ */ jsx(Typography, { variant: "label-M", className: "hidden md:block", children: sectionLink.label }),
          /* @__PURE__ */ jsx(ChevronIcon, { className: "h-4 w-4 md:hidden rtl:rotate-180" })
        ]
      }
    )
  ] });
};
var CarouselTitle_default = CarouselTitle;

// src/components/events/carousel/CarouselWithLink.tsx
import { Button as Button2, Carousel, Typography as Typography2 } from "@wbk/ui";
import { twMerge } from "tailwind-merge";
import { Link as Link2 } from "@wbk/config";
import { useAnalytics as useAnalytics2 } from "@wbk/analytics";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var CarouselWithLink = (_a) => {
  var _b = _a, {
    section,
    className,
    children,
    linkClassName,
    title
  } = _b, props = __objRest(_b, [
    "section",
    "className",
    "children",
    "linkClassName",
    "title"
  ]);
  var _a2, _b2;
  const link = (_b2 = (_a2 = section == null ? void 0 : section.webLinksCollection) == null ? void 0 : _a2.items) == null ? void 0 : _b2[0];
  const { trackEvent } = useAnalytics2();
  const trackSectionLink = () => {
    if (!(link == null ? void 0 : link.href)) return;
    trackEvent({
      event: "clicked_on_section_item",
      data: {
        type: "see_all",
        slug: link.href,
        section: section == null ? void 0 : section.id,
        label: link.label
      }
    });
  };
  return /* @__PURE__ */ jsxs2(
    Carousel,
    __spreadProps(__spreadValues({
      className: twMerge("relative p-1", className),
      options: { dragFree: true },
      title: title || /* @__PURE__ */ jsx2(CarouselTitle_default, { section, sectionLink: link }),
      arrows: "top"
    }, props), {
      children: [
        children,
        link && link.href && /* @__PURE__ */ jsx2(
          Button2,
          {
            as: Link2,
            href: link.href,
            onClick: trackSectionLink,
            shape: "solid",
            theme: "transparent",
            className: twMerge(
              "bg-body-level-1 hover:bg-body-level-1/70 relative h-full shrink-0 basis-36 md:invisible ltr:mr-4 rtl:ml-4",
              linkClassName
            ),
            target: link.isExternal ? "_blank" : void 0,
            rel: link.isExternal ? "noopener noreferrer" : void 0,
            "aria-label": link.label || "",
            children: /* @__PURE__ */ jsx2(Typography2, { variant: "label-M", children: link.label })
          }
        )
      ]
    })
  );
};
var CarouselWithLink_default = CarouselWithLink;

export {
  CarouselTitle_default,
  CarouselWithLink_default
};
//# sourceMappingURL=chunk-LVDZESI2.mjs.map